module.exports = __webpack_public_path__ + "img/ask-device.78f560fe.png";